/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { IdWithOrderDto } from './IdWithOrderDto';
import type { OfferTranslationCreate } from './OfferTranslationCreate';

export type OfferCreate = {
    name: string;
    effectiveFrom: string;
    effectiveTo: string;
    displayFrom: string;
    receiptAcceptanceDaysThreshold?: number;
    rewardScope: OfferCreate.rewardScope;
    rewardType: OfferCreate.rewardType;
    isParticipation?: boolean;
    type: OfferCreate.type;
    isRiceCalculationEnabled?: boolean;
    priceLow?: number;
    priceHigh?: number;
    quantity?: number;
    regions?: Array<'AB' | 'BC' | 'MB' | 'NB' | 'NL' | 'NT' | 'NS' | 'NU' | 'ON' | 'TB' | 'PE' | 'QC' | 'SK' | 'YT'>;
    maxRedeemsPerCollector?: number;
    displayRetailers: Array<IdWithOrderDto>;
    isExclusiveForRetailer?: boolean;
    translations: Array<OfferTranslationCreate>;
    displayPriorityZoneId: number;
    miles: number;
    offerCode: string;
    sponsorCode: string;
};

export namespace OfferCreate {

    export enum rewardScope {
        RECEIPT = 'RECEIPT',
        LINE_ITEM = 'LINE_ITEM',
    }

    export enum rewardType {
        FIXED_VALUE = 'FIXED_VALUE',
        PER_DOLLAR_SPENT = 'PER_DOLLAR_SPENT',
    }

    export enum type {
        SINGLE = 'SINGLE',
        PARTICIPATION = 'PARTICIPATION',
        BASE_SPENT = 'BASE_SPENT',
    }


}

